module.exports = __webpack_public_path__ + "static/media/005.4c7794ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/005.jpg
// module id = 302
// module chunks = 0